import { STACKED_GRAPH, TECHNOLOGY_GRAPH } from "./apiRoutes";
import { authData } from "./Service";

export const StackedGraphApi = async (data) => {
  const response = await authData.post(STACKED_GRAPH, data);
  return response?.data;
};

export const TechnologyGraphApi = async (data) => {
  const response = await authData.post(TECHNOLOGY_GRAPH, data);
  return response?.data;
};
